import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function StatistiquesCours() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;
  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = getToken();
        const response = await fetch(`${API_BASE}/enseignant/cours/get_stats.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.success) setStats(data.stats);
      } catch (error) {
        toast.error('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div><p className="mt-4 text-gray-600">Chargement...</p></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">📊 Statistiques des cours</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg"><div className="text-4xl mb-2">📚</div><p className="text-sm opacity-90">Total cours</p><p className="text-3xl font-bold">{stats?.total_cours || 0}</p></div>
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg"><div className="text-4xl mb-2">💰</div><p className="text-sm opacity-90">Revenus totaux</p><p className="text-3xl font-bold">{stats?.revenus_totaux?.toLocaleString() || 0} F</p></div>
        <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl p-6 text-white shadow-lg"><div className="text-4xl mb-2">🎓</div><p className="text-sm opacity-90">Étudiants</p><p className="text-3xl font-bold">{stats?.total_etudiants || 0}</p></div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">📈 Détails par cours</h2>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50"><tr><th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Cours</th><th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Prix</th><th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Acheteurs</th><th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Pages</th><th className="px-4 py-3 text-right text-sm font-semibold text-gray-600">Revenus</th></tr></thead>
            <tbody className="divide-y">{stats?.cours_details?.map(cours => (<tr key={cours.id_cours} className="hover:bg-gray-50"><td className="px-4 py-3 font-medium">{cours.titre}</td><td className="px-4 py-3 text-center text-green-600 font-semibold">{cours.prix?.toLocaleString() || 0} F</td><td className="px-4 py-3 text-center">{cours.nb_acheteurs || 0}</td><td className="px-4 py-3 text-center">{cours.nb_pages || 0}</td><td className="px-4 py-3 text-right font-semibold">{cours.revenus?.toLocaleString() || 0} F</td></tr>))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}